/**
 * Ant Design theme for the portal login page.
 *
 * The main `edjin` bundle's theme (src/main/ui/index.js) resolves its colours from CSS custom
 * properties declared in users/generalFiles/styles/styles.css. The portal is a public marketing page
 * that does not load that stylesheet, so this theme is deliberately self contained - it only sets the
 * font and the brand accent, and otherwise leans on Ant Design's own defaults.
 */
export const PORTAL_ANTD_THEME = {
    token: {
        colorPrimary: "#00588f",
        colorLink: "#00588f",
        colorTextDisabled: "rgba(0,0,0,0.55)",
        colorTextPlaceholder: "rgba(0,0,0,0.55)",
        fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
        fontSize: 15,
        borderRadius: 4,
    },
    components: {
        Button: {
            boxShadow: "none",
            boxShadowHover: "none",
            boxShadowActive: "none",
            controlHeightLG: 46,
        },
        Input: {
            controlHeightLG: 46,
        },
    },
    cssVar: {
        key: "antportal"
    },
    hashed: false
};
